import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Tooltip as TooltipMUI, Box } from '@material-ui/core'

/**
 * Props:
 * - title: React element that will be clicked to open/close the tooltip
 * - children: tooltip content
 * - placement: tooltip position (default: 'left')
 * - tooltipClass: custom class for the popper
 */
const Tooltip = ({ title, triggerType = 'hover', children, placement = 'left', tooltipClass }) => {
  const [open, setOpen] = useState(false)

  // triggerType: 'hover' | 'click'

  const handleToggle = e => {
    e.stopPropagation()
    setOpen(prev => !prev)
  }

  const handleClose = () => setOpen(false)

  if (triggerType === 'click') {
    return (
      <>
        {open && (
          <Box
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              width: '100vw',
              height: '100vh',
              zIndex: 2001,
              background: 'rgba(0,0,0,0.01)',
              pointerEvents: 'auto',
              cursor: 'default',
            }}
            onClick={handleClose}
            tabIndex={-1}
          />
        )}
        <TooltipMUI
          open={open}
          onClose={handleClose}
          onOpen={() => setOpen(true)}
          placement={placement}
          arrow
          classes={tooltipClass ? { popper: tooltipClass } : undefined}
          title={title}
          disableHoverListener
        >
          <Box
            onClick={handleToggle}
            onKeyDown={e => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault()
                handleToggle(e)
              }
            }}
            role="button"
            tabIndex={0}
            style={{
              cursor: 'pointer',
              display: 'inline-flex',
              alignItems: 'center',
              position: 'relative',
              zIndex: 2000,
            }}
          >
            {children}
          </Box>
        </TooltipMUI>
      </>
    )
  }
  // Default: hover
  return (
    <TooltipMUI
      placement={placement}
      arrow
      classes={tooltipClass ? { popper: tooltipClass } : undefined}
      title={title}
    >
      <Box style={{ cursor: 'pointer', display: 'inline-flex', alignItems: 'center' }}>
        {children}
      </Box>
    </TooltipMUI>
  )
}

Tooltip.propTypes = {
  title: PropTypes.node.isRequired,
  children: PropTypes.node.isRequired,
  placement: PropTypes.string,
  tooltipClass: PropTypes.string,
  triggerType: PropTypes.oneOf(['hover', 'click']),
}

Tooltip.defaultProps = {
  placement: 'left',
  tooltipClass: undefined,
  triggerType: 'hover',
}

export default Tooltip
